<template>
  <div
    class="modal fade"
    id="sys_apply_pay_task_payment_modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
          <h4 class="modal-title" id="myModalLabel">
            {{instance.define_name}}(当前节点 {{instance.node}}) No. {{instance.id}}
          </h4>
        </div>

        <!-- modal-body-->
        <div class="modal-body">
          <div class="form-horizontal">

            <div class="form-group">
              <label class="col-sm-2 control-label">申请时间:</label>
              <div class="col-sm-4">
                {{instance.create_at}}
              </div>
              <label class="col-sm-2 control-label">申请人:</label>
              <div class="col-sm-4">
                {{instance.initiator_name}}
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">基站名称:</label>
              <div class="col-sm-4">
                {{station.stst_comm}} {{station.stst_commname}}
              </div>
              <label class="col-sm-2 control-label">基站位置:</label>
              <div class="col-sm-4">
                {{station.stst_address}}
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">类型:</label>
              <div class="col-sm-4">
                <span v-if="payTask.type == 1">业主租金</span>
                <span v-if="payTask.type == 2">局方地租金</span>
                <span v-if="payTask.type == 3">局方杆租金</span>
                <span v-if="payTask.type == 4">业务协调费</span>
                <span v-if="payTask.type == 5">平台签约奖励</span>
                <span v-if="payTask.type == 6">杆塔资源费</span>
                <span v-if="payTask.type == 7">商务提成</span>
                (ID:{{payTask.id}})
              </div>
              <label class="col-sm-2 control-label">应结费金额:</label>
              <div class="col-sm-4">
                {{payTask.money}}
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">可结费时间:</label>
              <div class="col-sm-4">
                {{payTask.can_pay_time}}
              </div>
              <label class="col-sm-2 control-label">备注:</label>
              <div class="col-sm-4">
                {{payTask.remark}}
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">实际结费时间:</label>
              <div class="col-sm-4">
                {{context.实际结费时间}}
              </div>
            </div>

          </div>
        </div>

        <!-- modal-footer -->
        <div class="modal-footer">
          <button type="button" data-dismiss="modal" class="btn btn-primary" @click="judgeApprove">通过</button>
          <button type="button" data-dismiss="modal" class="btn btn-danger" @click="judgeReject">拒绝</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      instance: {}, // 实例
      context: {}, // 上下文
      payTask: [], // 结费任务
      station: {} // 基站信息
    }
  },

  props: [],

  mounted: function () {
    var self = this
  },

  methods: {
    initFunc: function (instance) {
      var self = this
      console.log('___initFunc 传入 instance', instance)
      self.context = JSON.parse(instance.context)
      self.instance = instance
      self.station = self.context.station
      self.payTask = self.context.payTask
      $('#sys_apply_pay_task_payment_modal').modal('show') // 展示 modal 框
    },
    judgeApprove: function () { // 审批通过
      this.submitJudge('approve')
    },
    judgeReject: function () { // 审批拒绝
      this.submitJudge('reject')
    },
    // 提交
    submitJudge: function (judge) {
      console.log('___judge', judge)
      var self = this
      var putData = {
        'judge': judge
      }
      self.global.axiosPut(
        self,
        `instance/${self.instance.id}/judge/`,
        putData,
        function (res) {
          console.log('审批返回结果', res)
          if (res.status === 'success') {
            alert('提交成功')
            $('#approval_list_table').bootstrapTable('refresh')
          } else
            alert('提交失败')
        },
        function () {
          alert('提交失败')
        }
      )
    }
  }
}
</script>

<style scoped>
  .overflow-hidden {
    overflow: hidden
  }

  .pay-task-panel {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  .pay-task-item {
    width: 60%;
    height: 100px;
    margin: 10px auto 0 auto;
    border-radius: 10px;
    background-color: #C4C4C4;
    display: flex;
  }

  .pay-task-info {
    width: 60%;
    font-size: 18px;
    padding: 5px 0 0 20px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    text-align: left;
  }

  .pay-task-info .can_pay_time, .pay_at {
    font-size: 15px;
  }

  .pay-task-info .remark {
    font-size: 15px;
    color: gray;
  }

  .pay-task-right {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 40%;
    padding: 5px 0 0 0;
    text-align: right;
  }

  .pay-task-right .type {
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/approvalCenter/instanceApplyPayTaskPayment.vue